import { Rate } from '@/utils/platform-api/__generated__/graphql';

export const STAY_FEES_COLLECTED_BY_RESORT_LABEL = 'Estimated Stay Fee';

export const STAY_FEES_COLLECTED_BY_RESORT_HELPER = '(Paid at resort)';

export const STAY_FEES_COLLECTED_BY_RESORT_DISCLAIMER =
  'Estimated fee collected by the resort at check-in. Amount may change without notice.';

export const BOOKING_AMOUNT_LABEL = 'Booking Amount';

type RateFeesSource = Pick<Rate, 'fee_details'>;

export const getRateStayFeesAmount = (rate: RateFeesSource): number =>
  rate.fee_details?.stay_collected_total ?? 0;

export const hasRateStayFees = (rate: RateFeesSource): boolean =>
  getRateStayFeesAmount(rate) > 0;

export const getRateBookingFeesTotal = (rate: RateFeesSource): number => {
  const total = rate.fee_details?.total ?? 0;

  return Math.max(0, total - getRateStayFeesAmount(rate));
};

export const getRateBookingAmount = (
  rate: Pick<Rate, 'amount' | 'fee_details'>
): number => (rate.amount ?? 0) + getRateBookingFeesTotal(rate);

export const getRateTotalBeforeTaxes = (
  rate: Pick<Rate, 'amount' | 'fee_details'>
): number => getRateBookingAmount(rate) + getRateStayFeesAmount(rate);

export const getRateDiscount = (rate: Pick<Rate, 'discount'>): number =>
  Math.max(0, rate.discount ?? 0);

export const getRateBaseAmount = (
  rate: Pick<Rate, 'amount' | 'discount'>
): number => (rate.amount ?? 0) + getRateDiscount(rate);

export const getRateTotalBeforeDiscounts = (
  rate: Pick<Rate, 'amount' | 'fee_details' | 'discount'>
): number => getRateTotalBeforeTaxes(rate) + getRateDiscount(rate);
